import debounce from "lodash/debounce";
import { queryClient } from "~/repository";
import * as actionTypes from "~/store/action_types";
import { getPersonalizedConfigOption } from "../selectors/selector.configOptions";

const invalidateTaskAndSubtasks = debounce(() => {
  queryClient.invalidateQueries(["workload-tasks"], { exact: false });
  queryClient.invalidateQueries(["workload-subtasks"], { exact: false });
  queryClient.invalidateQueries(["task-splits"], { exact: false });
}, 300);

const invalidateSubtasks = debounce(() => queryClient.invalidateQueries(["workload-subtasks"], { exact: false }), 300);
const invalidateTasks = debounce(() => {
  queryClient.invalidateQueries(["workload-tasks"], { exact: false });
  queryClient.invalidateQueries(["task-splits"], { exact: false });
}, 300);
const invalidateTimeRecords = debounce(
  () => queryClient.invalidateQueries(["workload-time-records"], { exact: false }),
  300
);

const workloadMiddleware =
  ({ getState }) =>
  (next) =>
  (action) => {
    const { type } = action;

    switch (type) {
      case actionTypes.MOVE_TASK_TO_TRASH_SUCCESS:
      case actionTypes.RESTORE_TASK_FROM_TRASH_SUCCESS:
      case actionTypes.COMPLETE_TASK_SUCCESS:
      case actionTypes.OPEN_TASK_SUCCESS:
      case actionTypes.RESCHEDULE_TASK_SUCCESS: {
        invalidateTimeRecords();
        invalidateTaskAndSubtasks();
        break;
      }
      case actionTypes.MOVE_TASK_TO_PROJECT_SUCCESS:
      case actionTypes.EDIT_TASK_SUCCESS: {
        invalidateTimeRecords();
        invalidateTasks();
        break;
      }
      case actionTypes.ADD_SUBTASK_SUCCESS:
      case actionTypes.EDIT_SUBTASK_SUCCESS:
      case actionTypes.COMPLETE_SUBTASK_SUCCESS:
      case actionTypes.MOVE_SUBTASK_TO_TRASH_SUCCESS: {
        invalidateSubtasks();
        break;
      }
      case actionTypes.ADD_CALENDAR_EVENT_EXCLUDED_DATES_SUCCESS:
      case actionTypes.EDIT_CALENDAR_EVENT_SUCCESS:
      case actionTypes.RESCHEDULE_ALL_CALENDAR_EVENTS_SUCCESS:
      case actionTypes.RESCHEDULE_EXCEPTION_CALENDAR_EVENT_SUCCESS:
      case actionTypes.MOVE_CALENDAR_EVENT_TO_TRASH_SUCCESS:
      case actionTypes.RESCHEDULE_THIS_AND_FUTURE_CALENDAR_EVENTS_SUCCESS:
        queryClient.invalidateQueries(["workload-events"], { exact: false });
        break;
      case actionTypes.ADD_TIME_RECORD_SUCCESS:
      case actionTypes.EDIT_TIME_RECORD_SUCCESS:
      case actionTypes.DELETE_TIME_RECORD_SUCCESS:
      case actionTypes.MOVE_TIME_RECORD_SUCCESS: {
        const trackedTimeOnWorkloadEnabled = getPersonalizedConfigOption(getState(), "tracked_time_on_workload");

        if (typeof trackedTimeOnWorkloadEnabled === "boolean" && trackedTimeOnWorkloadEnabled) {
          invalidateTimeRecords();
          invalidateTasks();
        }
        break;
      }
    }
    return next(action);
  };

export default workloadMiddleware;
